var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _vm.global.type == "manage"
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c("h4", [_vm._v("选择客户")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.customerChange },
                                  model: {
                                    value: _vm.customerValue,
                                    callback: function($$v) {
                                      _vm.customerValue = $$v
                                    },
                                    expression: "customerValue"
                                  }
                                },
                                _vm._l(_vm.customerData, function(item) {
                                  return _c("el-option", {
                                    key: item.number,
                                    attrs: {
                                      label: item.number + item.client_name,
                                      value: item.client_name
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      on: { input: _vm.ImgTypeChange },
                      model: {
                        value: _vm.imgType,
                        callback: function($$v) {
                          _vm.imgType = $$v
                        },
                        expression: "imgType"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "img_type_box" },
                        [
                          _c("el-radio-button", {
                            attrs: { label: "选择效果图" }
                          }),
                          _vm._v(" "),
                          _c("el-radio-button", {
                            attrs: { label: "选择底图" }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.imgType == "选择效果图"
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "infinite-scroll",
                              rawName: "v-infinite-scroll",
                              value: _vm.getSlide,
                              expression: "getSlide"
                            }
                          ],
                          staticClass: "slide_box",
                          style: "max-height:" + _vm.boxHeight + ";",
                          attrs: { "infinite-scroll-distance": "100" }
                        },
                        [
                          _vm.slideData.length > 0
                            ? _c(
                                "waterfall",
                                {
                                  staticClass: "slide_main",
                                  attrs: {
                                    col: 5,
                                    gutterWidth: 20,
                                    data: _vm.slideData,
                                    lazyDistance: 200
                                  }
                                },
                                [
                                  _vm._l(_vm.slideData, function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: "meterial" + index,
                                        staticClass: "item"
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,w_300",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "radio",
                                            on: {
                                              click: function($event) {
                                                return _vm.slideClick(index)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: index },
                                                model: {
                                                  value: _vm.slideCur,
                                                  callback: function($$v) {
                                                    _vm.slideCur = $$v
                                                  },
                                                  expression: "slideCur"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.space_type +
                                                      String(index + 1)
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.slideData.length <= 0
                            ? _c(
                                "div",
                                {},
                                [
                                  _c("el-empty", {
                                    attrs: {
                                      "image-size": 50,
                                      description: "暂无数据"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.imgType == "选择底图"
                    ? _c(
                        "div",
                        { staticClass: "slide_box2" },
                        [
                          _vm.slideData.length > 0
                            ? _c(
                                "waterfall",
                                {
                                  staticClass: "slide_main",
                                  attrs: {
                                    col: 5,
                                    gutterWidth: 20,
                                    data: _vm.slideData,
                                    lazyDistance: 200
                                  }
                                },
                                [
                                  _vm._l(_vm.slideData, function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: "meterial" + index,
                                        staticClass: "item"
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,w_300",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "radio",
                                            on: {
                                              click: function($event) {
                                                return _vm.slideClick(index)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: index },
                                                model: {
                                                  value: _vm.slideCur,
                                                  callback: function($$v) {
                                                    _vm.slideCur = $$v
                                                  },
                                                  expression: "slideCur"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.space_type +
                                                      String(index + 1)
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.slideData.length <= 0
                            ? _c(
                                "div",
                                {},
                                [
                                  _c("el-empty", {
                                    attrs: {
                                      "image-size": 50,
                                      description: "暂无数据"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c("div", { staticClass: "choose_img" }, [
                        _c("div", { staticClass: "img_title" }, [
                          _vm._v("当前选中的图片")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "img_wrapper" }, [
                          _c("img", {
                            attrs: {
                              src:
                                _vm.nowImg +
                                "?x-oss-process=image/resize,w_400",
                              alt: ""
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c(
                        "div",
                        { staticClass: "btn_analysis" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "success",
                                loading: _vm.analysisType
                              },
                              on: { click: _vm.onAnalysis }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.analysisType == true
                                    ? "正在解析"
                                    : "立即解析图片"
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.analysisType == true
                    ? _c(
                        "div",
                        { staticClass: "progress" },
                        [
                          _c("el-progress", {
                            attrs: { percentage: _vm.analysisPercent }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1 && _vm.hasAnalyzed
                    ? _c("div", {
                        staticClass: "analysis_result",
                        domProps: { innerHTML: _vm._s(_vm.analysisContent) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("文案改图")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c("div", {}, [
                        _c("div", { staticClass: "ai_para_box" }, [
                          _c("div", { staticClass: "cue_word" }, [
                            _c(
                              "div",
                              { staticClass: "item" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 5,
                                    placeholder: "请输入内容",
                                    resize: "none"
                                  },
                                  on: { input: _vm.contentInput },
                                  model: {
                                    value: _vm.zh_content,
                                    callback: function($$v) {
                                      _vm.zh_content = $$v
                                    },
                                    expression: "zh_content"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "lexicon" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                          plain: ""
                                        },
                                        on: { click: _vm.toLexicon }
                                      },
                                      [_vm._v("提示词库")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "translate" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                          plain: ""
                                        },
                                        on: { click: _vm.goLexicon }
                                      },
                                      [_vm._v("AI扩写润色")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("AI大模型")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c(
                        "div",
                        {},
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.aiCur,
                                callback: function($$v) {
                                  _vm.aiCur = $$v
                                },
                                expression: "aiCur"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ai_box" },
                                _vm._l(_vm.aiData, function(item, index) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: "ai" + index,
                                      attrs: { label: item.model_id }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.model_name +
                                            "(" +
                                            item.price +
                                            ")"
                                        )
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.steps >= 1
                    ? _c(
                        "div",
                        { staticClass: "btn_save" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { type: "success" },
                              on: { click: _vm.onSubmit }
                            },
                            [_vm._v("立即生成")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "prompt" }, [
                            _vm._v(
                              "（本月剩余使用额度 " +
                                _vm._s(_vm.global.money) +
                                "元）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultStatus != 0
                    ? _c("div", { staticClass: "effect_box" }, [
                        _vm.resultStatus == 2
                          ? _c("div", { staticClass: "complete" }, [
                              _c("div", { staticClass: "list" }, [
                                _c("div", { staticClass: "item" }, [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.slideData[_vm.slideCur].photo_url,
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v("修改前")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.effectData[0].file_url,
                                      alt: ""
                                    },
                                    on: { click: _vm.toEffectDetail }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v("修改后")
                                  ])
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resultStatus == 1
                          ? _c(
                              "div",
                              { staticClass: "progress" },
                              [
                                _c("el-progress", {
                                  attrs: { percentage: _vm.percent }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.dialogVisitable == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        top: "15vh",
                        "show-close": false,
                        center: true
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _vm.dialogCur != -1
                        ? _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: { src: _vm.detailImg, alt: "" }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisitable == "effectDetail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        width: "70%",
                        "show-close": true,
                        center: ""
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "detail_box" }, [
                        _vm.effectData.length > 0
                          ? _c("div", { staticClass: "img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.effectData[0].file_url,
                                  alt: ""
                                }
                              })
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "tool", attrs: { gutter: 20 } },
                        [
                          _vm.effectData[0].workblank_id == 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-picture",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toPath("/effectvideo")
                                        }
                                      }
                                    },
                                    [_vm._v("图生视频")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.effectData[0].workblank_id == 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon:
                                          _vm.favoriteType == true
                                            ? "el-icon-star-off"
                                            : "el-icon-star-on",
                                        plain: ""
                                      },
                                      on: { click: _vm.toFavorite }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.favoriteType == true
                                            ? "收藏"
                                            : "取消收藏"
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.effectData[0].workblank_id != 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-refresh",
                                        plain: ""
                                      },
                                      on: { click: _vm.toReplace }
                                    },
                                    [_vm._v("替换底图")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              attrs: {
                                span:
                                  _vm.effectData[0].workblank_id == 0 ? 8 : 12
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-download",
                                    plain: ""
                                  },
                                  on: { click: _vm.toDownload }
                                },
                                [_vm._v("下载")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisitable == "lexicon"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        "custom-class": "lexicon_box",
                        top: "15vh",
                        "show-close": true,
                        center: true,
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.activeIndex,
                            mode: "horizontal"
                          },
                          on: { select: _vm.handleSelect }
                        },
                        _vm._l(_vm.lexiconLabelData, function(item, index) {
                          return _c(
                            "el-menu-item",
                            {
                              key: "lexiconLabel" + index,
                              attrs: { index: index.toString() }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lexicon_list" },
                        [
                          _vm.lexiconData[_vm.activeIndex].length > 0
                            ? _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.lexiconCheckList,
                                    callback: function($$v) {
                                      _vm.lexiconCheckList = $$v
                                    },
                                    expression: "lexiconCheckList"
                                  }
                                },
                                _vm._l(
                                  _vm.lexiconData[_vm.activeIndex],
                                  function(item, index) {
                                    return _c("el-checkbox", {
                                      key: "lexicon" + index,
                                      attrs: { label: item.word }
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.lexiconData[_vm.activeIndex].length <= 0
                            ? _c(
                                "div",
                                {},
                                [
                                  _c("el-empty", {
                                    attrs: {
                                      "image-size": 50,
                                      description: "暂无数据"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.lexiconCheckList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "choose_list" },
                            _vm._l(_vm.lexiconCheckList, function(item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: "choose" + index,
                                  attrs: {
                                    closable: true,
                                    "disable-transitions": true,
                                    type: "success"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.handleClose(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item) +
                                      "\n          "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4, offset: 19 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.confirmLexicon }
                                },
                                [_vm._v("确定")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-593568e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593568e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Effect/AiEdit.vue
// module id = null
// module chunks = 